import { DataSegmentTypeEnum } from 'sonata-static-storage/lib/common/common.types';

import type { NormalizedUserAudienceSegment } from 'sonata-static-storage/lib/common/common.types';
import type { AudienceGroup } from '../AudienceTargeting';

/**
 * Only included groups can be the active one (where new included segments go) and there must always be one
 * while any included group exists: keep the current active included group or fall back to the first one.
 */
export function ensureActiveIncludedGroup(groups: AudienceGroup[]): AudienceGroup[] {
  const hasActiveIncludedGroup = groups.some(group => group.active && group.type === 'included');
  const firstIncludedGroupId = groups.find(group => group.type === 'included')?.id;

  return groups.map(group => ({
    ...group,
    active:
      group.type === 'included' && (hasActiveIncludedGroup ? Boolean(group.active) : group.id === firstIncludedGroupId)
  }));
}

/** Excluding a campaign events (retargeting) segment that is currently included removes the retargeting */
export function isExcludingIncludedRetargeting(
  segments: NormalizedUserAudienceSegment[],
  groups: AudienceGroup[]
): boolean {
  return segments.some(
    segment =>
      segment.type === DataSegmentTypeEnum.campaignEvents &&
      groups.some(group => group.type === 'included' && group.segmentIds.includes(segment.segmentId))
  );
}
